import React, { useEffect, useState } from 'react';
import "../../../styles/pricingStyle.css";
import verified from "../../../assets/verified.svg"
import CardDetail from './CardDetail';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from 'react-redux';
import { getPricePerUSer } from '../../services/operations/profileAPI';
import StripeContainer from './StripeContainer';



const Pricing = () => {

  const [price,setPrice]=useState([]);
  const [upgrade,setUpgrade]=useState(false);
  const dispatch=useDispatch();
  const token=useSelector((state)=>state.auth.token)
  const user=useSelector((state)=>state.profile.user)

  const getPrice=async()=>{
    const result=await dispatch(getPricePerUSer(token));
    setPrice(result.data)
  }

  useEffect(()=>{
    getPrice()
  },[])

  const handleUpgrade=()=>{
    setUpgrade(true)

  }


  return (
    <div
      className="jobpost-dashboard"
      style={{
        background:
          "radial-gradient(50% 50% at 50% 50%, #2D76FD 0%, #FFFFFF 100%)",
        minHeight: "100vh",
        padding: "20px",
        marginTop: "91px",
      }}
    >
      <div className="pricing-container">
        <p className="pricing-heading">PRICING</p>
        <p className="pricing-desc">
          Explore for free and unlock our additional features later on
        </p>
          <div className="pricing-card">
            <div className='pricing-first-section'>
            <div className="plan-type"><span className='center-plan-circle'></span><span style={{fontWeight:"700",fontSize:"28px",fontFamily:"Nunito Sans"}}>Professional</span></div>
            <div className="plan-desc">
              <button className='button-subscription-monthly'>Monthly</button>
                <p className='plan-desc-detail'>
                    Find, shortlist, and hire your ideal candidates faster. Choose to
              upgrade as it fits your hiring needs.
                </p>
               {/* <p className='learn-more-pricing'>Learn more</p> */}
            </div>
           
            </div>
            <div className="features">
                <p className='feature-heading'>Features</p>
              <p className='feature-heading-list'><img src={verified} alt='verified'/><span>Access to unlimited Candidate Database</span></p>
              <p className='feature-heading-list'><img src={verified} alt='verified'/><span>Host multiple Career Page Generator</span></p>
              <p className='feature-heading-list'><img src={verified} alt='verified'/><span>Applicant Tracking System access</span></p>
              <p className='feature-heading-list'><img src={verified} alt='verified'/><span>AI-Powered Smart Filters (Skills, Location)</span></p>
            </div>
            <div className="price-box">
              {!user?.is_premium ? (<>
              <p className="price">${price.price_per_user}</p>
              <p className="per-month">Per user/Month</p>
              <button className="upgrade-btn" onClick={handleUpgrade}>Upgrade</button>
              </>):(
                <>
                 <p className="price-premium">${price.price_per_user}</p>
              <p className="per-month-premium">Per user/Month</p>
                <button className="upgrade-btn-premium">Your Current Plan</button></>
               
              )}
              
            </div>
          </div>
          {
            upgrade &&  <StripeContainer price={price}/>
          }
         
      </div>
    </div>
  );
};

export default Pricing;
